// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__16yBk","vLegacy":"SelectSecondary_vLegacy__2MwgD","error":"SelectSecondary_error__1SuwD","disabled":"SelectSecondary_disabled__17KtD"};